import { useLocation, useNavigate, Link } from "react-router-dom";
import withRouter from "../../withRouter";
import React, { useEffect, useState } from "react";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import Footer from "../../Component/Footer";
import { FormikTextField } from "../../CommonComponents/FormField";
import { Form, Formik } from "formik";
import ProjectManagementServices from "../ProjectManagementServices";
import { Spinner } from "react-bootstrap";
import { currentTenant, userid } from "../../Common/Credentials";

const ProjectStoreNewItem = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const [projectId, setProjectId] = useState();
    const [projectName, setProjectName] = useState("");
    const [projectCode, setProjectCode] = useState("");
    const [remark, setRemark] = useState("");

    useEffect(() => {
        if (location.state && location.state.projectId) {
            setProjectName(location.state.projectName);
            setProjectCode(location.state.projectCode);
            setRemark(location.state.remark);
            setProjectId(location.state.projectId);
        }
    }, [location.state]);

    const onSubmit = async (values) => {
        setLoader(true);
        const data = {
            projectName: values.projectName,
            projectCode: values.projectCode,
            tenantId: currentTenant,
            remark: values.remark,
            createdby: userid,
            updatedby: userid,
        };
        try {
            await ProjectManagementServices.createProjectItem(data);
            setLoader(false);
            navigate("/projectstoretable");
        } catch (error) {
            console.error("Error creating project item:", error);
            setLoader(false);
        }
    };

    const validate = (values) => {
        const errors = {};
        if (!values.projectName) {
            errors.projectName = "Select Project Name";
        }
        if (!values.projectCode) {
            errors.projectCode = "Select Project Code";
        }
        return errors;
    };

    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="card card-info">
                    <ol className="breadcrumb float-sm-right">
                        {/* <Link as="button" className="text-secondary" to={-1}>
                            ❮ Back &nbsp;&nbsp;
                        </Link> */}
                        <li className="breadcrumb-item text-secondary">
                            <Link to="/projectmanagement">Home</Link>
                        </li>
                        <li className="breadcrumb-item text-secondary">
                            <Link to="/projectstoretable">Store</Link>
                        </li>
                        <li className="breadcrumb-item active">New Item</li>
                    </ol>
                    <section className="content">
                        <div className="container-fluid p-3">
                            <div className="row card-body">
                                <div className="col-12">
                                    <Formik
                                        initialValues={{
                                            projectName: projectName || "",
                                            projectCode: projectCode || "",
                                            remark: remark || ""
                                        }}
                                        enableReinitialize
                                        validate={validate}
                                        onSubmit={onSubmit}
                                    >
                                        {({ values, handleChange }) => (
                                            <Form>

                                                <div className="form-row">

                                                    <fieldset className="form-group col-md-4">
                                                        <FormikTextField
                                                            lassName="form-control"
                                                            name="projectName"
                                                            label="Project Name"
                                                            value={values.projectName}
                                                            onChange={handleChange}
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </fieldset>
                                                    <fieldset className="form-group col-md-4">
                                                        <FormikTextField
                                                            lassName="form-control"
                                                            name="projectCode"
                                                            label="Project Code"
                                                            value={values.projectCode}
                                                            onChange={handleChange}
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </fieldset>
                                                    <FormikTextField
                                                        name="remark"
                                                        label="Remark"
                                                        value={values.remark}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        variant="outlined"
                                                    />
                                                    <div className="text-center mt-3">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-sm hovbuttonColour"
                                                            disabled={loader}
                                                        >
                                                            {loader ? (
                                                                <Spinner
                                                                    animation="border"
                                                                    size="sm"
                                                                />
                                                            ) : (
                                                                "Submit"
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default withRouter(ProjectStoreNewItem);